import { CustomPagination } from "@/components/pagination/CustomPagination";
import { usePaginationData } from "@/components/pagination/usePaginationData";

//To enforce single source of truth
export const pagination = {
  Pagination: CustomPagination,
  usePaginationData,
};
